module.exports = {
  /**
   * Make an element full-screen by hiding certain elements
   * and toggle the text in the action element.
   *
   * Requires the $actionEl to have three data attributes:
   * data-exit-fullscreen-label - {string}
   * data-go-fullscreen-label - {string}
   *
   * @param {jQuery} $actionEl
   * @param {jQuery} $hideEls
   * @param {jQuery} $portlet - the portlet that should take the most available screen resolution
   */
  addFullScreenControl: function ($actionEl, $hideEls, $portlet) {
    if (!$actionEl.length) {
      return;
    }

    $actionEl.parents('.govuk-width-container').css({
      'width': 'auto',
      'max-width': 'none',
      'padding': '0 30px'
    });

    $actionEl.text($actionEl.data("go-fullscreen-label"));

    var $content = $("#main-content");
    $content.css({'padding-bottom': '0'});
    var $body = $("body");

    function _setPortletHeight() {
      var viewportHeight =
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight;

      var otherElsHeight = 0;
      var $otherEls = $(".action-list");

      if ($otherEls.length) {
        otherElsHeight =
          $otherEls.outerHeight() +
          Number($otherEls.css("marginBottom").split("p")[0]);
      }

      $portlet.height(viewportHeight - otherElsHeight);
    }

    $actionEl.on("click", function () {
      if ($actionEl.data("state") === "fullscreen") {
        // Close the full-screen view
        $hideEls.slideDown();

        $actionEl
          .text($actionEl.data("go-fullscreen-label"))
          .data("state", "inset");


        $content.animate({}, function () {
          $body.removeClass('fullscreen');
        });
      } else {
        $hideEls.slideUp();

        $actionEl
          .text($actionEl.data("exit-fullscreen-label"))
          .data("state", "fullscreen");

        $body.addClass("fullscreen");
        _setPortletHeight();
      }
    });
  },
};
